import { GET, PATCH, POST, DELETE } from "Data/API/Request";
import { deserializeJsonApiData, serializeJsonApiData } from "Data/Utils/Json";
import {
	IApiUser, IDataPage, IIndexSignature, ILoginUserArgs, IResetPasswordArgs, IUser, IWithApiData
} from "Interfaces";

export const loginUser = (loginUserArgs: ILoginUserArgs) => {
	return POST<IApiUser>("auth/login", loginUserArgs);
};

export const logoutUser = () => {
	return POST("auth/logout");
};

export const forgotPassword = (email: string) => {
	return POST("auth/forgot-password", { email });
};

export const resetPassword = (args: IResetPasswordArgs) => {
	return POST("auth/reset-password", { ...args });
};

export const getUsers = (token: string, params?: IIndexSignature<string | number | undefined>) => {
	return GET<IWithApiData<Partial<IUser>[]>>("users", token, { ...params }).then((response) => {
		return deserializeJsonApiData<Partial<IUser>[]>(response).then((user: Partial<IUser>[]) => {
			return { ...response, data: user } as IDataPage<IUser>;
		});
	});
};

export const getUser = (id: string, token: string) => {
	return GET<IWithApiData<IUser>>(`users/${ id }`, token)
		.then((response) => {
			return deserializeJsonApiData<IUser>(response);
		});
};

export const createUser = (user: IUser, token: string) => {
	return POST<IWithApiData<IUser>>(
		"users",
		serializeJsonApiData("user", user),
		token
	).then((response) => {
		return deserializeJsonApiData<IUser>(response);
	});
};

export const updateUser = (user: Partial<IUser>, token: string) => {
	return PATCH<IWithApiData<IUser>>(
		`users/${ user?.id }`,
		token,
		serializeJsonApiData("user", user)
	).then((response) => {
		return deserializeJsonApiData<IUser>(response);
	});
};

export const deleteUser = (id: string, token: string) => {
	return DELETE(`users/${ id }`, token)
		.then(() => id);
};
